import { $can } from '@pendo/permissions';
import { STATUS_TYPES } from '@/orchestrate/journeys/status.constants';
const { ACTIVE } = STATUS_TYPES;

function checkPermission (appId, action, entity = 'journey', source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateJourney ({ appId, source, target }) {
    return checkPermission(appId, 'create', 'journey', source, target);
}

export function canUpdateJourney ({ appId, source, target, journey }) {
    const derivedSource = deriveSourceFromStatus(source, journey?.status);

    return checkPermission(appId, 'edit', 'journey', derivedSource, target);
}

export function canDeleteJourney ({ appId, source, target, journey }) {
    const derivedSource = deriveSourceFromStatus(source, journey?.status);

    return checkPermission(appId, 'remove', 'journey', derivedSource, target);
}

export function canPublishJourney ({ appId, source, target }) {
    return checkPermission(appId, 'publish', 'journey', source, target);
}

function deriveSourceFromStatus (source, journeyStatus) {
    if (!source && journeyStatus === ACTIVE) {
        return 'active';
    }

    return source;
}
